// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  StatsTable,AnimatedView,ScoreCard
}                         from '../../components';

class Sales extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
    })
  };

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Sales');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Sales');
  }

  render() {
    const {
      statsTable,scoreCard
    } = this.props;
    
    const { 
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded
      }
    } = this.props;    

    return(
      <AnimatedView>
        <div className="row">
          <div className="col-md-12">
            <StatsTable bigTable={true} name="sales_performance" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>        
        </div>        
        <div className="row">
          <div className="col-md-12">
            <StatsTable bigTable={true} name="daily_demo_conversion" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>        
        </div>

      </AnimatedView>
    );
  }
}

export default Sales;



// WEBPACK FOOTER //
// ./src/app/views/sales/Sales.js